import ouiBase from '@goldwasserexchange/oui';
import useDimensions from 'react-cool-dimensions';
import { ResizeObserver } from '@juggle/resize-observer';

export const useHeadingSectionIndexedMeasure = (setHeight) => {
  const headingIndex = ouiBase.HeadingSection.useHeadingSectionIndex();
  const { observe, unobserve } = useDimensions<HTMLElement>({
    useBorderBoxSize: true,
    polyfill: ResizeObserver,
    onResize: ({ height: elementHeight }) => {
      setHeight((currentHeights) => {
        const currentHeightsCopy = [...currentHeights];
        currentHeightsCopy[headingIndex] = elementHeight;
        return currentHeightsCopy;
      });
    },
  });
  return [observe, unobserve] as [typeof observe, typeof unobserve];
};
